import { ACCEPT_FILETYPE } from '@app/constants/UpLoadModal';
import getExtensionFromFileName from '@app/libs/file/getExtensionFromFileName';

export default function checkIsContractableFileName(fileName: string): boolean {
  const extension = getExtensionFromFileName(fileName).slice(1);
  const set = new Set(ACCEPT_FILETYPE);
  return !!(extension && set.has(extension));
}
